module.exports = __webpack_public_path__ + "img/eduardocisternas.e443a176.jpg";